export default __webpack_public_path__ + "static/media/InviteScreenshot.d97f872a.png";